module.exports = require('./SplashPage');